import { eventPeriod, type EventResponse } from '@lifetimeline/shared';

import type { TranslationKey } from '../i18n/index.js';

type Translate = (key: TranslationKey, params?: Record<string, string | number>) => string;

/**
 * 기간을 화면에 쓸 한 줄로.
 *
 * 재료(`2020.01`, `2020.02`, 13개월)는 `shared`가 만들고, **말로 만드는 일은
 * 여기서** 한다 — `shared`는 언어를 모르는 자리라, 거기서 붙이면 영어 화면에
 * 한국어가 튀어나온다.
 *
 * 시작 달을 안 적은 기록은 `null`이다. 그런 기록은 지금처럼 축에 연도만 찍힌다.
 */
export function eventPeriodText(event: EventResponse, t: Translate, now?: Date): string | null {
  const period = eventPeriod(event, now);
  if (period === null) {
    return null;
  }

  // 같은 달에 시작하고 끝난 일은 `2020.01 ~ 2020.01 · 0개월`이 아니라 그냥 `2020.01`이다
  if (period.end === period.start) {
    return period.start;
  }

  const end = period.end ?? t('timeline.periodNow');
  return `${period.start} ~ ${end} (${durationText(period.months, t)})`;
}

/**
 * 개월 수를 말로.
 *
 * 열두 달이 넘으면 해로 끊는다 — `37개월`은 세어 봐야 알고, `3년 1개월`은
 * 바로 읽힌다.
 */
function durationText(months: number, t: Translate): string {
  if (months < 12) {
    return t('timeline.periodMonths', { count: months });
  }
  const years = Math.floor(months / 12);
  const rest = months % 12;
  return rest === 0
    ? t('timeline.periodYears', { count: years })
    : t('timeline.periodYearsMonths', { years, months: rest });
}
